// extracted by mini-css-extract-plugin
export var subtitle = "Title-module--subtitle--3Ap3_";
export var primary = "Title-module--primary--1tEBY";
export var subheadline = "Title-module--subheadline--36wfl";
export var callToAction = "Title-module--callToAction--2MDQZ";
export var moving = "Title-module--moving--3OKrM";
export var titleArea = "Title-module--titleArea--3-KHD";
export var finnishNewsletter = "Title-module--finnishNewsletter--27BOt";